import {Component, OnInit} from '@angular/core';
import {ZkService} from '../../../services/zk.service';
import {ZkUser} from '../../../classes/zk/ZkUser';
import {NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ZkUserEditComponent} from '../zk-user-edit/zk-user-edit.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {OfficeService} from '../../../services/office.service';
import {Office} from '../../../classes/Office';
import {ngxLoadingAnimationTypes} from 'ngx-loading';
import {ZkUserGroup} from '../../../classes/zk/ZkUserGroup';

@Component({
  selector: 'app-zk-user-list',
  styleUrls: ['./zk-user-list.component.scss'],
  templateUrl: './zk-user-list.component.html',
})
export class ZkUserListComponent implements OnInit {

  public users: ZkUser[];
  public loading = false;
  public errorMessage: string;
  private currentDialog = null;
  public isDeviceUnavailable = false;
  public offices: Office[];
  public officesForm: FormGroup;
  public primaryColour = '#ffffff';
  public secondaryColour = '#ccc';
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public ZkUserGroup = ZkUserGroup;

  constructor(private zkService: ZkService,
              private modalService: NgbModal,
              private officeService: OfficeService,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.officeService.getAll().subscribe(response => this.offices = response);

    this.officesForm = this.formBuilder.group({
      officeId: [null, Validators.required]
    });

    this.officesForm.controls.officeId.valueChanges.subscribe((officeId) => {
      this.updateUserList(officeId);
    });
  }

  updateUserList(officeId: number): void {
    this.loading = true;
    this.zkService.getUsers(officeId).subscribe({
      next: (users) => {
        this.users = users;
        this.isDeviceUnavailable = false;
      },
      error: (error) => {
        this.isDeviceUnavailable = true;
        this.errorMessage = error.error.error;
      },
      complete: () => this.loading = false
    });
  }

  openEditModal(officeId: number, user: ZkUser): void {
    this.currentDialog = this.modalService.open(ZkUserEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-zk-user-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.user = user;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {

          const startDate =
            this.convertNgbDate(result.controls.startDate.value, 0, 0, 0, false);
          result.controls.startDate.setValue(startDate);

          const endDate =
            this.convertNgbDate(result.controls.endDate.value, 23, 59, 59, true);
          result.controls.endDate.setValue(endDate);

          result.removeControl('validPeriod');

          const zkUser = new ZkUser(result.value);
          zkUser.authorizeTimezoneId = 1; // TODO hardcode
          zkUser.authorizeDoorId = 1; // TODO hardcode

          this.loading = true;
          this.zkService.addOrEdit(officeId, zkUser).subscribe({
            next: () => this.updateUserList(officeId),
            error: (error) => this.errorMessage = error.error.error,
            complete: () => this.loading = false
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(officeId: number, user: ZkUser): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-zk-user-delete-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete user ' + user.name + ' from device?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.loading = true;
        this.zkService.deleteUser(officeId, user.id).subscribe({
          next: () => this.updateUserList(officeId),
          error: (error) => this.errorMessage = error.error.error,
          complete: () => this.loading = false
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  convertNgbDate(ngbDate: NgbDateStruct, hours: number, minutes: number, seconds: number, nextDayTransfer: boolean): Date {

    if (!ngbDate) {
      return null;
    }

    // if hours is 00:00, then set next day
    if (hours === 0 && minutes === 0 && nextDayTransfer) {
      ngbDate.day = ngbDate.day + 1;
    }

    const date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day, hours, minutes, seconds);

    return ngbDate ? date : null;
  }

}
